<template>
  <div class="profile">
    <el-menu
      id="profile-menu"
      active-text-color="#ffd04b"
      background-color="#99a9bf"
      class="el-menu-vertical"
      :default-active="$route.name"
      text-color="#fff"
    >
      <file-upload />
      <el-button id="removeImageButton" type="info" @click="removeImageHandler"
        >Remover foto</el-button
      >
      <h2 id="username">{{ $store.state.user.username }}</h2>
      <el-menu-item index="Profile" @click="$router.push('/user/profile')">
        <i class="el-icon-menu"></i>
        <span>Dados Pessoais</span>
      </el-menu-item>
      <el-menu-item index="Comments" @click="$router.push('/user/comments')">
        <i class="el-icon-document"></i>
        <span>Meus comentários</span>
      </el-menu-item>
      <el-menu-item index="Settings" @click="$router.push('/user/settings')">
        <i class="el-icon-setting"></i>
        <span>Configurações</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import FileUpload from "./FileUpload.vue";

export default {
  components: {
    "file-upload": FileUpload,
  },

  data() {
    return {};
  },

  methods: {
    menuSelect(index) {
      this.$router.push({
        name: index,
      });
    },

    removeImageHandler() {
      this.emitter.emit("removeUploaderImage");
    },
  },
};
</script>
<style scoped>
#removeImageButton {
  margin-top: 10px;
}

#username {
  color: white;
}

#profile-menu {
  height: 600px;
  padding-top: 30px;
  position: relative;
  height: 200vh;
}

.profile {
  text-align: center;
}
</style>
